<template>
    <div>
        <b-form ref="form" @submit.prevent="submit">
            <!-- id, active -->
            <b-form-group
                class="mb-0"
                label-cols="6"
                :label="record.id === 0 ? '' : $t('form.id_value', {value: record.id})"
                label-size=""
                label-class="pt-0"
            >
                <b-form-checkbox
                    id="active"
                    class="float-right"
                    switch
                    v-model="record.active"
                    name="active"
                    value="true"
                    unchecked-value="false"
                >
                    {{activeText}}
                </b-form-checkbox>
            </b-form-group>
            <!-- meta -->
            <b-form-group
                :label="$tc('form.meta.data', 0)"
                class="mb-0 group-title p-0"
                label-class="font-weight-bold"
                label-align-sm="left"
                label-cols-sm="12"
                label-size=""
            >
                <b-form-row>
                    <!-- name -->
                    <b-form-group
                        id="group-meta.name"
                        class="col-sm-12 col-md-6"
                        label-class="mb-0"
                        :label="$t('form.name')"
                        label-for="meta.name"
                        description=""
                        :state="valid_metaName"
                    >
                        <b-form-input
                            id="meta.name"
                            v-model="record.meta.name"
                            :state="valid_metaName"
                            required
                            :placeholder="$t('form.required_field')"
                        ></b-form-input>
                    </b-form-group>
                    <!-- mark -->
                    <b-form-group
                        id="group-meta.mark"
                        class="col-sm-12 col-md-6"
                        label-class="mb-0"
                        :label="$t('register.mark')"
                        label-for="meta.mark"
                        description=""
                        :state="valid_metaMark"
                    >
                        <b-form-input
                            id="meta.mark"
                            :state="valid_metaMark"
                            v-model="record.meta.mark"
                            required
                            :placeholder="$t('form.required_field')"
                        ></b-form-input>
                    </b-form-group>
                </b-form-row>
            </b-form-group>
            <!-- foreign_data -->
            <b-form-group
                class="mb-0 group-title p-0"
            >
                <b-form-row>
                    <!-- unit group -->
                    <b-form-group
                        id="group-unit_group_id"
                        class="col-sm-12 col-md-6"
                        label-class="mb-0"
                        :label="$tc('register.group', 1)"
                        label-for="unit_group_id"
                        description=""
                        :state="valid_unitGroup"
                    >
                        <b-form-select
                            id="unit_group_id"
                            v-model="record.unit_group_id"
                            :options="unit_groups"
                            required
                            :state="valid_unitGroup"
                        >
                        </b-form-select>
                    </b-form-group>
                </b-form-row>
            </b-form-group>
            <!-- locale-->
            <b-form-group
                :label="$t('form.locale.locale')"
                class="mb-0 group-title p-0"
                label-class="font-weight-bold"
                label-align-sm="left"
                label-cols-sm="12"
                label-size=""
            >
                <b-card no-body>
                    <b-tabs pills card>
                        <b-tab :title="locale.locale"
                               :active="locale.locale === $i18n.locale"
                               v-for="locale in data.locale" style="background: white">
                            <FormUnitBasicLocale
                                :locale="locale.locale"
                                :record.sync="setRecordLocale[locale.locale]"
                            ></FormUnitBasicLocale>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-form-group>
            <!--  -->
        </b-form>
    </div>
</template>

<script>
import utilsGeneral from "../../../utils/utilsGeneral";
import FormUnitBasicLocale from "./FormUnitBasicLocale";
// @group Form.REGISTER
export default {
    name: "FormUnitBasic",
    components: {FormUnitBasicLocale},
    props: {
        form: {
            valid: false,
            record: {},
        },
        data: {},
        modalBus: Object,
    },
    data() {
        return {
            valid: null,
            record: {
                id: 0,
                active: false,
                order: 0,
                unit_group_id: null,
                meta: {
                    name: '',
                    mark: ''
                },
                locale: {},
            },
            unit_groups: [],
        }
    },
    mounted() {
        this.modalBus.$on('submit', this.submit);
        // <-- set foreign data -->
        this.setUnitGroups();
        // <--  -->
        if (this.form.record != null) {
            this.$set(this, 'record', this.form.record);
        }
    },
    methods: {
        // <-- set selects data -->
        setUnitGroups() {
            let unit_groups = [
                {value: null, text: '/', disabled: false},
            ];
            let meta = false;
            let locale = {};
            this.data.unit_groups.forEach((unit_group, index) => {
                meta = false;
                locale = unit_group.locale[this.$i18n.locale];
                // <-- if missing locale data -->
                if (locale === undefined) {
                    meta = true;
                    locale = unit_group.meta;
                }
                unit_groups.push(
                    {
                        value: unit_group.id,
                        text: locale.name + (meta ? this.$t('form.meta.message', {msg: this.$t('form.name').toLowerCase()}) : ''),
                        disabled: false
                    }
                );
            });
            // <--  -->
            this.$set(this, 'unit_groups', unit_groups);
        },
        // <-- form -->
        submit() {
            if (this.$refs.form === undefined) {
                return;
            }
            this.valid = this.$refs.form.checkValidity();

            this.$set(this.form, 'record', this.record);
            this.$set(this.form, 'valid', this.valid);
        }
    },
    computed: {
        activeText: {
            get() {
                return !this.record.active || this.record.active === 'false' || this.record.active === undefined
                    ? this.$t('form.inactive')
                    : this.$t('form.active');
            }
        },
        setRecordLocale() {
            this.data.locale.forEach((value, index) => {
                // <-- add missing locale record -->
                if (Object.keys(this.record.locale).indexOf(value.locale) === -1) {
                    this.$set(this.record.locale, value.locale, {
                        name: '',
                        mark: '',
                        notes: ''
                    });
                }
            });
            return this.record.locale;
        },
        valid_unitGroup() {
            if (this.valid === null) {
                return null;
            }
            return this.record.unit_group_id > 0 ? null : false;
        },
        // <-- meta -->
        valid_metaName() {
            if (this.valid === null) {
                return null;
            }
            return this.record.meta.name.length > 0 ? null : false;
        },
        valid_metaMark() {
            if (this.valid === null) {
                return null;
            }
            return this.record.meta.mark.length > 0 ? null : false;
        },
    },
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
